module.exports = {
      id: "shortvideo-usage",
      viewBox: "0 0 15 19",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#shortvideo",
      toString: function () {
        return this.url;
      }
    }